export interface CredentialRequest {
  username: string;
}

export interface RegistrationResponse {
  publicKey: PublicKey;
}

export interface PublicKey {
  challenge: string;
  rp: {
    name: string;
  };
  user: RegistrationResponseUser;
  attestation: AttestationConveyancePreference;
  pubKeyCredParams: PublicKeyCredentialParameters[];
  status: string;
}

interface RegistrationResponseUser {
  id: string;
  name: string;
  displayName: string;
}

export interface OtpPinRequest {
  pin: string;
}

export interface BadgePinRequest {
  pin: string;
}

export interface OtpRegistrationKeyRequest {
  otp: string;
  pin: string;
}

export interface MfaKeyRegistrationRequest {
  otp: string;
}

export interface AuthnResponse {
  otpRegistered: boolean;
}

export interface AuthnRequest {
  credential: Credential;
  otp: string;
  nickname: string;
}

interface Credential {
  rawId: string;
  response: AuthnRequestResponse;
  authenticatorAttachment: string;
  clientExtensionResults?: {};
  id: string;
  type: string;
}

interface AuthnRequestResponse {
  attestationObject: string;
  authenticatorData: string;
  publicKey: string;
  publicKeyAlgorithm: string;
  transports: string;
  clientDataJSON: string;
}

export interface User {
  id: string;
  displayName: string;
  alias: string;
  activeCredentialsCount: number;
  otpEnabled: boolean;
  otpPinSet: boolean;
  status: string;
  statusReason?: string;
  statusUpdateTimestamp?: string;
  lockExpiresAt?: string;
  credentialsInfo?: Record<string, CredentialInfo>;
  lastAuthSuccess?: string;
}

export enum UserStatus {
  New = "new",
  Enabled = "enabled",
  Disabled = "disabled",
  Locked = "locked",
}

export enum CredentialStatus {
  Active = "active",
  Revoked = "revoked",
}

export interface CredentialInfo {
  serialNumber: string;
  nickname?: string;
  registeredAt: string;
  lastUsed: string;
  status: CredentialStatus;
  statusUpdateTimestamp?: string;
  rpId: string;
}

export interface UpdateCredentialNicknameRequest {
  alias: string;
  credentialId: string;
  nickname: string;
}

export interface RevokeCredentialRequest {
  alias: string;
  credentialId: string;
  reason: string;
}

export interface UserResponse {
  user: User;
  groups: string[];
}

export interface LoginResponse {
  challenge: string;
  allowCredentials: AllowCredentials[];
  status: string;
}

interface AllowCredentials {
  type: "public-key";
  id: string;
  transports: AuthenticatorTransport[];
}
